import type { ReactNode } from "react";
import { Icon } from "../Icon/Icon";

type ButtonSize = "Large" | "Medium" | "Small";
type ButtonType = "Primary" | "Secondary" | "Critical" | "Tertiary";

interface RoundButtonProps {
	size?: ButtonSize;
	children?: ReactNode;
	type?: ButtonType;
	disabled?: boolean;
	icon?: string;
	loadingIcon?: string;
	onClick?: () => void;
	loading?: boolean;
}

export const RoundButton = ({
	size = "Medium",
	children,
	type = "Primary",
	disabled,
	icon,
	loadingIcon,
	onClick,
	loading,
}: RoundButtonProps) => {
	const baseClassName = `flex px-4 py-2 justify-center items-center ${children ? "gap-2" : ""} rounded-full overflow-hidden box-border`;

	const getTypeClass = () => {
		if (disabled) {
			switch (type) {
				case "Primary":
					return "bg-color_background_primary_2 text-white cursor-not-allowed";
				case "Secondary":
					return "bg-color_background_grey_1 text-white cursor-not-allowed";
				case "Critical":
					return "bg-color_background_negative_3 text-white cursor-not-allowed";
				case "Tertiary":
					return "bg-color-White text-color_text_primary_1 cursor-not-allowed";
				default:
					return "bg-color-White text-color_text_primary_1 cursor-not-allowed";
			}
		} else {
			switch (type) {
				case "Primary":
					return "bg-color_background_primary_3 text-white hover:bg-color_background_primary_4 active:bg-color_background_primary_5";
				case "Secondary":
					return "bg-color_background_grey_1 text-color_text_grey_5 hover:bg-color_background_grey_2 active:bg-color_background_grey_3";
				case "Critical":
					return "bg-color_background_negative_3 text-white hover:bg-color_background_negative_4 active:bg-color_background_negative_5";
				case "Tertiary":
					return "bg-color-White text-color_text_primary_3 hover:bg-color_background_grey_1 active:bg-color_background_grey_2";
				default:
					return "bg-White text-color_text_primary_3 hover:bg-color_background_grey_1 active:bg-color_background_grey_2";
			}
		}
	};

	const buttonSize =
		size === "Large"
			? "ButtonL"
			: size === "Medium"
				? "ButtonM"
				: size === "Small"
					? "ButtonS"
					: "ButtonM";

	return (
		<button
			className={`${baseClassName} ${getTypeClass()}`}
			disabled={disabled || loading}
			onClick={onClick}
		>
			{icon && !loading && <Icon iconName={icon} size={size} />}
			{loading && loadingIcon && (
				<Icon iconName={loadingIcon} size={size} loading={loading} />
			)}
			{!loading && <div className={buttonSize}>{children}</div>}
		</button>
	);
};
